/* eslint-disable prefer-arrow-callback, react/button-has-type */
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { addUtils, applyDefaultClass } from './class-name-helpers';

const basePropTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  dossier: PropTypes.bool,
};

const baseDefaultProps = {
  className: undefined,
  dossier: false,
};

export const Link = React.forwardRef(
  function Link({
    children,
    className,
    dossier,
    ...props
  }, ref) {
    const variants = {
      'ss_link--dossier': dossier,
    };
    const defaultClassName = applyDefaultClass(variants, 'ss_link--dossier');
    const { restProps, utilClassNames } = addUtils(props);

    return (
      <a
        className={clsx('ss_link', className, utilClassNames, variants, defaultClassName)}
        ref={ref}
        {...restProps}
      >
        {children}
      </a>
    );
  },
);

Link.propTypes = basePropTypes;
Link.defaultProps = baseDefaultProps;
